// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1729":"9b1ceabd","6036":"cb5d7045","7318":"cb5d7045","7443":"06e6972a","9139":"c8fc2065","9914":"06e6972a"}[chunkId] + ".chunk.css";
};